module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAADFBMVEXeEBj62tz///8AJH3NdBjEAAAAMklEQVR4AWMY3GAUhOIAIQyrcIAVg0JmVOY/DvCHfJlRmVGZUZnBXR6MyuCpswY1GAUAAApZSP8DXLwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/th.png
// module id = 642
// module chunks = 0